import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { DropdownSvg } from "../../../svgFiles/DropdownSvg";

const MultiSelectBox = ({ label, options = [], value = [], onChange }) => {
  const [selectedValues, setSelectedValues] = useState(value);
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedValues(value);
  }, [value]);

  const handleCheckboxChange = (optionValue) => {
    const newSelectedValues = selectedValues.includes(optionValue)
      ? selectedValues.filter((val) => val !== optionValue)
      : [...selectedValues, optionValue];

    setSelectedValues(newSelectedValues);
    onChange(newSelectedValues);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="mb-3" ref={dropdownRef}>
      <label className="cmn_label form-label">{label}</label>
      <Dropdown
        show={show}
        onToggle={(isOpen) => setShow(isOpen)}
        className="custom_multiselect"
      >
        <Dropdown.Toggle id="dropdown-basic">
          {selectedValues.length > 0
            ? options
                .filter((opt) => selectedValues.includes(opt.value))
                .map((opt) => opt.label)
                .join(", ")
            : "Select options"}
          {DropdownSvg}
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-100">
          {options.map((option) => (
            <li key={option.value} className="dropdown_item">
              <label>
                <input
                  type="checkbox"
                  checked={selectedValues.includes(option.value)}
                  disabled={option.isDisabled} // <-- ✅ now supports disabling
                  onChange={() => handleCheckboxChange(option.value)}
                />
                {option.label}
              </label>
            </li>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MultiSelectBox;
